import moment from 'moment';
import { IReportData } from 'redhotpie-shared-lib/types/report';
import configApp from '../../app.json';
import * as types from '../constants/actionTypes';
import * as CONSTANTS from '../constants/constants';
import { ACTION_NAME } from '../constants/constants';
import * as utils from '../functions/utils';
import { Dispatch } from '../hooks/useRedux';
import { IAction } from '../interfaces/IAction';
import { PagingInfo } from '../models/pagingInfo';
import logService from '../services/logService';
import userService from '../services/userService';
import * as myStore from '../store/myStore';
import { updateChatServerTime, updateServerTimeGroupChat } from './conversationInboxAction';
import { IGlobalPreviewMedia } from 'modules/GlobalPreviewMedia';
import { IPreviewMedia } from '../../modules/modals/PreviewPhotoModal/PreviewPhotoModal';

const isNative = !configApp || !configApp.isWebApp;

function getCommonStateReducer() {
  return myStore.getStore().getState().commonStateReducer;
}

function getSelectedPeerVCard() {
  return myStore.getStore().getState().conversationsReducer.selectedPeerVcard;
}

export function selectPhotoPreview(img: IPreviewMedia | null, dataSet: any = undefined): IAction {
  return { type: types.SELECT_PREVIEW_PHOTO, data: img, dataSet };
}

function getVideoCallReducer() {
  return myStore.getStore().getState().videoCallReducer;
}

export function getAboutRhpRequest(): IAction {
  return { type: types.GET_ABOUT_RHP_REQUEST };
}

export function showNotificationPhotoLikeModal() {
  return { type: types.SHOW_NOTIFICATION_PHOTO_LIKE_MODAL };
}

export function hideNotificationPhotoLikeModal() {
  return { type: types.HIDE_NOTIFICATION_PHOTO_LIKE_MODAL };
}

export function showNotificationUserInterestModal() {
  return { type: types.SHOW_NOTIFICATION_USER_INTEREST_MODAL };
}

export function hideNotificationUserInterestModal() {
  return { type: types.HIDE_NOTIFICATION_USER_INTEREST_MODAL };
}

export function getAboutRhpSuccess(data: any): IAction {
  return { type: types.GET_ABOUT_RHP_SUCCESS, data };
}

export function showReportV2Modal(data: IReportData): IAction {
  return { type: types.SHOW_REPORT_V2, data };
}

export function hideReportV2Modal(): IAction {
  return { type: types.HIDE_REPORT_V2 };
}

export function clearReportV2Data(): IAction {
  return { type: types.CLEAR_REPORT_V2_DATA };
}

export function getAboutRhpFailed(mess: string): IAction {
  return { type: types.GET_ABOUT_RHP_FAILED, data: mess };
}

export function updateMessageNotificationError(data: any): IAction {
  return { type: types.UPDATE_MESSAGE_NOTIFICATION_ERROR, data };
}

export function updateErrorCallAPI(): IAction {
  return { type: types.UPDATE_ERROR_API };
}

export function updateCommonStateReducerSuccess(data: any): IAction {
  return { type: types.UPDATE_COMMON_STATE_REDUCER, data };
}

export function updateDataSpotlightModalSuccess(userId: string, params: any): IAction {
  return { type: types.UPDATE_DATA_SPOTLIGHT_SUCCESS, userId, params };
}

export function updateStateCommonState(dataKey: string[], data: any): IAction {
  return { type: types.UPDATE_STATE_COMMON_STATE, dataKey, data };
}

export function toggleNotificationGroupJoinRequest(toggle: boolean) {
  return { type: types.TOGGLE_NOTIFICATION_GROUP_JOIN_REQUEST, data: toggle };
}

export function toggleNotificationInvitation(type: string, toggle: boolean) {
  return { type: types.TOGGLE_NOTIFICATION_INVITATION, data: { toggle, type } };
}

export function toggleNotificationGroupActivity(toggle: boolean) {
  return { type: types.TOGGLE_NOTIFICATION_GROUP_ACTIVITY, data: toggle };
}

export function toggleNotificationGroupJoins(toggle: boolean) {
  return { type: types.TOGGLE_NOTIFICATION_GROUP_JOINS, data: toggle };
}

export function updateMessageNotificationErrorSuccess(data: any) {
  return (dispatch: Dispatch) => {
    dispatch(updateMessageNotificationError(data));
  };
}

export function updateMenuSelected(data: any): IAction {
  return { type: types.UPDATE_MENU_SELECTED, data };
}

export function onShowConfirmModal(data: any): IAction {
  return { type: types.SHOW_CONFIRM_MODAL, data };
}

export function updateConfirmModal(params: any): IAction {
  return { type: types.UPDATE_DATA_CONFIRM_MODAL, params };
}

export function onCloseConfirmModal() {
  return (dispatch: Dispatch) => {
    dispatch(onShowConfirmModal(null));
  };
}

export function updateCommonStateReducer(data: any) {
  return (dispatch: Dispatch) => {
    dispatch(updateCommonStateReducerSuccess(data));
  };
}

export function toggleInAppNotification(data: any): IAction {
  return { type: types.TOGGLE_IN_APP_NOTIFICATION, data };
}

export function updateInAppNotificationDataSuccess(data: any): IAction {
  return { type: types.UPDATE_DATA_IN_APP_NOTIFICATION, data };
}

export function resetInAppNotificationDataSuccess(): IAction {
  return { type: types.RESET_DATA_IN_APP_NOTIFICATION };
}

export function toggleCreateNewPasswordModal({
  isShowModal,
  callbackCreatePasswordSuccess,
  callbackCreatePasswordFailed,
  des,
}: {
  isShowModal: boolean;
  des?: string;
  callbackCreatePasswordSuccess?: (password: string) => void;
  callbackCreatePasswordFailed?: () => void;
}) {
  return {
    type: types.TOGGLE_CREATE_PASSWORD_MODAL,
    data: { isShowModal, callbackCreatePasswordSuccess, callbackCreatePasswordFailed, des },
  };
}
export function toggleVerifyPasswordModal({
  isShowModal,
  callbackVerifyPasswordSuccess,
  des,
}: {
  isShowModal: boolean;
  des?: string;
  callbackVerifyPasswordSuccess?: (password: string) => void;
}) {
  return { type: types.TOGGLE_VERIFY_PASSWORD_MODAL, data: { isShowModal, callbackVerifyPasswordSuccess, des } };
}

export function setSupportNotificationManager(status: boolean): IAction {
  return { type: types.SUPPORT_NOTIFICATION_MANAGER, data: !!status };
}

export function setIsDesktop(status: boolean): IAction {
  return { type: types.SET_IS_DESKTOP, data: !!status };
}

export function addInAppNotificationDataToManagerSuccess(data: any): IAction {
  return { type: types.ADD_IN_APP_NOTIFICATION_TO_MANAGER, data };
}

export function removeInAppInManagerSuccess(index: number): IAction {
  return { type: types.REMOVE_IN_APP_NOTIFICATION_FROM_MANAGER, data: index };
}

export function toggleSensitiveSafeMode(data: any, params?: any): IAction {
  return { type: types.TOGGLE_SENSITIVE_MODAL, data, params };
}

export function toggleShareURLModal({
  toggle,
  seoURL = null,
  titleHeader = '',
}: {
  toggle: boolean;
  seoURL?: string | null;
  titleHeader?: string;
}): IAction {
  return {
    type: types.TOGGLE_SHARE_URL_MODAL,
    data: { toggle, seoURL, titleHeader },
  };
}

export function removeInAppInManager(index: number) {
  return (dispatch: Dispatch) => {
    dispatch(removeInAppInManagerSuccess(index));
  };
}

export function toggleRecentlySentPhoto(toggle: boolean, isSending: boolean): IAction {
  return { type: types.TOGGLE_RECENTLY_SENT_PHOTO, data: toggle, isSending };
}

export function toggleSetMessageImageDurationModal(toggle: boolean, canSetDefaultValue?: boolean): IAction {
  return { type: types.TOGGLE_SET_MESSAGE_IMAGE_DURATION_MODAL, data: { toggle, canSetDefaultValue } };
}

export function setTimeDurationSelectionValue(timeDuration: string) {
  return { type: types.SET_TIME_DURATION_SELECTION_VALUE, data: timeDuration };
}

export function getUserSharedPhotosSuccess(data: any): IAction {
  return { type: types.GET_USER_SHARED_PHOTOS_SUCCESS, data };
}

export function addUserMediaSuccess(data: any): IAction {
  return { type: types.ADD_USER_MEDIA_SUCCESS, data };
}

export function patchUserSharedPhotosSuccess(data: any): IAction {
  return { type: types.PATCH_USER_SHARED_PHOTOS_SUCCESS, data };
}

export function patchUserSharedVideosSuccess(data: any): IAction {
  return { type: types.PATCH_USER_SHARED_VIDEOS_SUCCESS, data };
}

export function updateInAppNotificationData(data: any) {
  const selectedPeerVCard = getSelectedPeerVCard();
  const videoCallReducer = getVideoCallReducer();
  const isMessageGroup = data && data.data && data.data.action && data.data.action.name === ACTION_NAME.SEND_GROUP_MESSAGE;
  const roomJid = (data && data.data && data.data.actionData && data.data.actionData.roomJid) || '';
  return (dispatch: Dispatch) => {
    if (
      data &&
      data.data &&
      data.data.type === CONSTANTS.NOTIFICATION_COUNT_TYPE.SENDMESSAGE &&
      data.data.action?.name !== CONSTANTS.ACTION_NAME.JOIN_GROUP_CHAT &&
      selectedPeerVCard &&
      ((selectedPeerVCard.userId && selectedPeerVCard.userId.toString() === data.from) ||
        (isMessageGroup && selectedPeerVCard.xmppId === roomJid))
    ) {
      if (!videoCallReducer.minimize) {
        if (!isNative) {
          const isMobile = utils.phoneDetect();
          if (
            (!isMobile && !videoCallReducer.isFullScreen) || // In case fullscreen Desktop video call, in-app notification till shown
            (isMobile && videoCallReducer.requestType !== 'call') // Or video call modal not shown
          ) {
            return;
          }
        } else if (videoCallReducer.requestType !== 'call') {
          return;
        }
      }
      return;
    }
    dispatch(resetInAppNotificationDataSuccess());
    dispatch(updateInAppNotificationDataSuccess(data));
    dispatch(toggleInAppNotification(true));
    const commonStateReducer = getCommonStateReducer();
    if (commonStateReducer.isSupportNotificationManager) {
      data.index = new Date().getTime();
      data.keyUnique = Math.random().toString(36).substring(5);
      dispatch(addInAppNotificationDataToManagerSuccess(data));
    }
  };
}

export function logError(logData: any) {
  return () => {
    return logService.addLog(logData).then(() => {});
  };
}

export function updateAppBackgroundTimeSuccess(date: string): IAction {
  return { type: types.APP_IN_BACKGROUND_TIME, date };
}

export function updateAppBackgroundTime(date: string) {
  return (dispatch: Dispatch) => {
    dispatch(updateAppBackgroundTimeSuccess(date));
  };
}

export function createUserAppRating(score: number) {
  return (dispatch: Dispatch) => {
    return userService.createUserAppRating(score).then(res => {
      return res;
    });
  };
}

export function getAboutRhp() {
  return (dispatch: Dispatch) => {
    dispatch(getAboutRhpRequest());
    return userService.getAboutRhp().then(res => {
      if (res && res.success) {
        dispatch(getAboutRhpSuccess(res.data));
      } else {
        dispatch(getAboutRhpFailed(res.message || ''));
      }
      return res;
    });
  };
}

export function getSearchFriendsOnlineRequest(): IAction {
  return { type: types.GET_SEARCH_FRIEND_ONLINE_REQUEST };
}

export function getSearchFriendsOnlineSuccess(data: any, params: any): IAction {
  return { type: types.GET_SEARCH_FRIEND_ONLINE_SUCCESS, data, params };
}

export function getSearchFriendsOnlineFailed(): IAction {
  return { type: types.GET_SEARCH_FRIEND_ONLINE_FAILED };
}

export function getSearchFavouriteOnlineRequest(): IAction {
  return { type: types.GET_SEARCH_FAVOURITES_ONLINE_REQUEST };
}

export function getSearchFavouriteOnlineSuccess(data: any, params: any): IAction {
  return { type: types.GET_SEARCH_FAVOURITES_ONLINE_SUCCESS, data, params };
}

export function getSearchFavouriteOnlineFailed(): IAction {
  return { type: types.GET_SEARCH_FAVOURITES_ONLINE_FAILED };
}

export function modalAuthenticate(status: boolean) {
  return (dispatch: Dispatch) => {
    dispatch({ type: types.MODAL_AUTHENTICATE, status });
  };
}

export function getSearchFriendsOnline(params: any) {
  return (dispatch: Dispatch) => {
    dispatch(getSearchFriendsOnlineRequest());
    return userService.getSearchFriendsOnline(params).then(res => {
      if (res && res.success) {
        dispatch(getSearchFriendsOnlineSuccess(res.data, params));
      } else {
        dispatch(getSearchFriendsOnlineFailed());
      }
      return res;
    });
  };
}

export function getSearchFavoritesOnline(params: any) {
  return (dispatch: Dispatch) => {
    dispatch(getSearchFavouriteOnlineRequest());
    return userService.getSearchFavouriteOnline(params).then(res => {
      if (res && res.success) {
        dispatch(getSearchFavouriteOnlineSuccess(res.data, params));
      } else {
        dispatch(getSearchFavouriteOnlineFailed());
      }
      return res;
    });
  };
}

export function getUserSharedPhotos(params: any) {
  return (dispatch: Dispatch) => {
    return userService.getUserSharedPhotos(params).then(res => {
      if (res && res.success) {
        dispatch(
          getUserSharedPhotosSuccess({
            params,
            data: res.data,
            paginationInfo: res.paginationInfo,
          })
        );
      } else {
        dispatch(
          getUserSharedPhotosSuccess({
            params,
            data: [],
            paginationInfo: new PagingInfo(),
          })
        );
      }
      return res;
    });
  };
}

export function patchUserSharedPhotos(params: any) {
  return (dispatch: any) => {
    return userService.patchUserSharedPhotos(params).then(res => {
      if (res && res.success && res.message === '') {
        dispatch(patchUserSharedPhotosSuccess(params));
      }
      return res;
    });
  };
}

export function deleteUserVideos(videoIds: any) {
  return (dispatch: any) => {
    return userService.deleteUserVideos(videoIds).then(res => {
      if (res && res.success) {
        dispatch(patchUserSharedVideosSuccess(videoIds));
      }
      return res;
    });
  };
}

export function updateMetricsStatus(status: boolean) {
  return (dispatch: any) => {
    return dispatch({ type: types.UPDATE_METRICS_STATUS, status });
  };
}

export function updateWindowDimensions(data: any): IAction {
  return { type: types.UPDATE_WINDOW_DIMENSIONS, data };
}

export function updateChatSystemDownModalStatus(status: boolean): IAction {
  return { type: types.UPDATE_CHAT_SYSTEM_DOWN_MODAL_STATUS, data: status };
}

export function updateUnavailableMessengerShown(show: boolean) {
  return (dispatch: Dispatch) => dispatch({ type: types.UPDATE_UNAVAILABLE_MESSENGER, data: show });
}

export function updateUnavailableChatroomShown(show: boolean) {
  return (dispatch: Dispatch) => dispatch({ type: types.UPDATE_UNAVAILABLE_CHATROOM, data: show });
}

export function getServerTime() {
  return (dispatch: Dispatch) => {
    return userService.getServerTime().then(res => {
      if (res?.success) {
        const time = moment(res.data.time).diff(moment());
        dispatch(updateServerTimeGroupChat(time));
        dispatch(updateChatServerTime(time));
      }
      return res;
    });
  };
}

export function toggleMyGroupsModal(show: boolean) {
  return (dispatch: Dispatch) => dispatch({ type: types.TOGGLE_MY_GROUPS_MODAL, data: show });
}

export function toggleJoinedGroupsModal(show: boolean) {
  return (dispatch: Dispatch) => dispatch({ type: types.TOGGLE_JOINED_GROUPS_MODAL, data: show });
}

/**
 *
 * @param metadataGroupMemberModal {clubId: number, isOwner?: boolean, isMemberView?: boolean, tabId?: number}
 * @returns
 */
export function toggleGroupMemberModal(metadataGroupMemberModal?: {
  groupId: number;
  isOwner?: boolean;
  isMemberView?: boolean;
  tabId?: number;
}) {
  return (dispatch: Dispatch) => dispatch({ type: types.TOGGLE_GROUP_MEMBER_MODAL, data: metadataGroupMemberModal });
}

/**
 *
 * @param metadataGlobalPreviewMediaModal {previewParentType: PreviewMediaType; parentId: number; getParentDetailAction?: (id: number) => Promise<IApiResponse>; getMediaAction: (id: number, params?: any) => Promise<IApiResponse>; initMedia: IDataMedia[]; initIndexMedia?: number; totalItems?: number; isViewerOwner?: boolean; textHeader?: string; subTextHeader?: string}
 * @returns
 */
export function toggleGlobalPreviewMediaModal(metadataGlobalPreviewMediaModal?: IGlobalPreviewMedia) {
  return (dispatch: Dispatch) => dispatch({ type: types.TOGGLE_GLOBAL_PREVIEW_MEDIA_MODAL, data: metadataGlobalPreviewMediaModal });
}
